export default __webpack_public_path__ + "static/media/Icon_Top_Action_Pane.c397f46a.svg";